<script lang="ts">
  import { UnsignedMattersState, type CloseActionType } from "./LeadUnsigned/UnsignedMattersState.svelte";
  import LeadUnsignedDialog from "./LeadUnsignedDialog.svelte";
  import OfferStep from "./LeadUnsigned/OfferStep.svelte";
  import SignatureStep from "./LeadUnsigned/SignatureStep.svelte";
  import ConfirmRejectionStep from "./LeadUnsigned/ConfirmRejectionStep.svelte";
  import SuccessStep from "./LeadUnsigned/SuccessStep.svelte";
  import SraFeeCap from "./LeadUnsigned/SraFeeCap.svelte";
  import toggleState from "../lib/toggleState.svelte";

  let {
    manager,
    openOnMount,
    afterClose = (action: CloseActionType) => {},
  }: {
    manager: UnsignedMattersState,
    openOnMount: boolean,
    afterClose?: (CloseActionType) => void,
  } = $props();

  let showHelp = toggleState(false);
</script>

<LeadUnsignedDialog {manager} {openOnMount} {afterClose}>
  <div class={showHelp.value ? "hidden" : "contents"}>
    {#if manager.currentStep == manager.offerStep}
      <OfferStep {manager}>
        {#snippet introduction(plural)}
          {#if plural}
            Our records show you may have Personal Contract Purchase (PCP) claims regarding your financial agreements below.
          {:else}
            Our records show you may have a Personal Contract Purchase (PCP) claim regarding your financial agreements below.
          {/if}
          <a href="#what_is_pcp" onclick={showHelp.toggle} class="text-primary underline whitespace-nowrap">What is a PCP claim?</a>
        {/snippet}
      </OfferStep>
    {:else if manager.currentStep == manager.signatureStep}
      <SignatureStep {manager}>
        {#snippet disclosure()}<SraFeeCap />{/snippet}

        {#snippet header(plural)}
          We believe you may have {plural ? "claims" : "a claim"} for {plural ? "these financial agreements" : "this financial agreement"}
        {/snippet}
      </SignatureStep>
    {:else if manager.currentStep == manager.rejectionStep}
      <ConfirmRejectionStep {manager} toggleHelp={showHelp.toggle} />
    {:else if manager.currentStep == manager.successStep}
      <SuccessStep {manager} />
    {/if}
  </div>

  {#if showHelp.value}
    <h2 class="ui-title mb-3">What Is a PCP Claim?</h2>
    <p class="text-base mb-3">
      A PCP claim refers to a legal or financial complaint related to a Personal Contract Purchase (PCP), Hire Purchase (HP), or Lease (PCH) agreement — popular forms of car finance in the UK. These claims typically arise when a car buyer believes the PCP agreement was mis-sold or not clearly explained by the dealership or finance provider, resulting in higher interest rates or secret commissions.
    </p>
    <h2 class="ui-title mb-3">Common Reasons for PCP Claims</h2>
    <p class="text-base mb-3">
      PCP claims are based on mis-selling, such as failing to explain discretionary commission arrangements, secret commissions, or unfair interest rates. These claims could have happened without your knowledge, and your time to act is limited.
    </p>
    <div class="floating-footer">
      <button class="btn btn-primary" onclick={showHelp.toggle}>Back</button>
    </div>
  {/if}
</LeadUnsignedDialog>
